import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PianoOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"piano_off"}/>
}
